<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">首页管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>轮播图</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回轮播图列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item
            label="轮播图片"
            prop="pic"
          >
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data='tokenData'
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form.pic"
                :src="form.pic"
                class="avatar"
              >
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：375px*210px</div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="弹窗类型"
            prop="open_type"
          >
            <el-select
              v-model="form.open_type"
              placeholder="请选择"
            >
              <el-option
                v-for="option in openTypeOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          v-if="form.open_type == 2"
            label="角色权限"
            prop="role_type"
          >
            <el-select
              multiple
              v-model="form.role_type"
              placeholder="请选择"
            >
            <el-option
                label="康减系列VIP会员"
                value="-0.5"
              ></el-option>
              <el-option
                label="康减系列高级会员"
                value="-0.4"
              ></el-option>
              <el-option
                label="康减系列荣誉会员"
                value="-0.3"
              ></el-option>
              <el-option
                label="康减系列市代"
                value="1.1"
              ></el-option>
              <el-option
                label="康减系列省代"
                value="2.1"
              ></el-option>
              <el-option
                label="康减系列CEO"
                value="3.1"
              ></el-option>
              <el-option
                label="VIP门店"
                value="0.0"
              ></el-option>
              <el-option
                label="联盟店"
                value="1.0"
              ></el-option>
              <el-option
                label="优秀联盟店"
                value="1.05"
              ></el-option>
              <el-option
                label="市代"
                value="2.0"
              ></el-option>
              <el-option
                label="省代"
                value="3.0"
              ></el-option>
              <el-option
                label="CEO"
                value="4.0"
              ></el-option>
              <el-option
                label="总经销商"
                value="5.0"
              ></el-option>
              <el-option
                label="合伙人"
                value="2.2"
              ></el-option>
              <el-option
                label="董事"
                value="4.2"
              ></el-option>
              <el-option label="经销商" value="4.8"></el-option>
              <el-option
                label="区域总监"
                value="5.1"
              ></el-option>
              <el-option
                label="城市加盟商"
                value="5.2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="链接类型"
            prop="info_type"
          >
            <el-select
              v-model="form.info_type"
              placeholder="请选择"
            >
              <el-option
                v-for="option in typeOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-show="form.info_type == 2">
            <UEditor
              :config=config
              ref="ueditor"
            ></UEditor>
          </el-form-item>
          <el-form-item
            label="商品ID"
            prop="info_id"
            v-if="form.info_type == 1"
          >
            <el-input
              v-model="form.info_id"
              style="width:70%"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="显示状态"
            prop="isShow"
          >
            <el-select
              v-model="form.isShow"
              placeholder="请选择"
            >
              <el-option
                v-for="option in options"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
import UEditor from "@/components/ueditor.vue";
var _ = require("lodash");
export default {
  name: "addBanner",
  components: { UEditor },
  data() {
    return {
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/static/ueditor/"
      },
      options: [{ text: "显示", value: "1" }, { text: "不显示", value: "0" }],
      typeOptions: [{ text: "商品", value: "1" },{ text: "文章", value: "2" },{ text: "图片", value: "3" }],
      openTypeOptions: [{ text: "轮播图", value: "1" },{ text: "弹窗", value: "2" }],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      good: null,
      wordName: "新增",
      addFormRule: {
        pic: [{ required: true, message: "请上传轮播图片", trigger: "blur" }],
        info_type: [
          { required: true, message: "请选择链接类型", trigger: "blur" }
        ],
        open_type: [
          { required: true, message: "请选择弹窗类型", trigger: "blur" }
        ],
        isShow: [{ required: true, message: "请选择是否展示", trigger: "blur" }]
      },
      addLoading: false,
      form: {
        isShow: null,
        pic: null,
        open_type:1,
        role_type:[],
        info_type: 1,
        info_id: null,
        id: null,
        content: null
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    var good = this.$route.query.good;
    that.good = good;
    var para = {
      id: that.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      that.wordName = "修改";
      that.form.id = good.id;
      that.form.info_type = good.infoType.toString();
      that.form.open_type = good.openType.toString();
      if (good.roleType != null && good.roleType.length > 0)
      {
        that.form.role_type = (good.roleType.substr(1, good.roleType.length - 2)).split(',')
      }
      that.form.info_id = good.infoId;
      that.form.content = good.content;
      that.form.isShow = good.isShow.toString();
      if (good.infoType == 2) {
        console.info(that.$refs.ueditor)
        that.$refs.ueditor.setContentInfo(good.content);
      }
      that.form.pic = good.pic;
    } else {
      that.form.info_type = '1';
      that.form.role_type = [];
      that.form.open_type = '1';
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    backList() {
      this.$router.push({
        path: "/banner_list"
      });
    },

    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          if (parseInt(that.form.info_type) == 1) {
            if (that.form.info_id == null) {
              that.$message.error({
                showClose: true,
                message: "请输入商品id",
                duration: 2000
              });
              return;
            }
          } else if (parseInt(that.form.info_type) == 2) {
            let content = this.$refs.ueditor.getUEContent();
            para.content = content;
            if (
              para.content == null ||
              para.content == "" ||
              para.content == "<p>请输入内容</p>"
            ) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请填写文章",
                duration: 2000
              });
              return;
            }
          }
          if (that.form.open_type && that.form.open_type == 2)
          {
            if (
              para.role_type == null ||
              para.role_type == "" ||
              para.role_type.length == 0
            ) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请选择角色权限",
                duration: 2000
              });
              return;
            }
            para.role_type = ',' + that.form.role_type.join(',') + ',';
          } else {
            para.role_type = null;
          }
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.banner_add(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/addBanner.vue